import { TipoStatusAgendamentoContato } from "constants/EnumTipoStatusAgendamentoContato";
import { useAgendamentoContatoContext } from "context/gestaoCobranca/AgendamentoContatoContext";
import { Col, Row } from "react-bootstrap";
import { CustomDatePicker } from "shared/components/date/CustomDatePicker";
import InputSearch from "shared/components/input/InputSearch";
import CustomSelect from "shared/components/select/CustomSelect";
import SelectCondominios from "shared/components/select/selectCondominios/SelectCondominios";
import { SelectOptionType } from "types/select/SelectOptionType";

export default function FiltrosAgendamentosContatos() {
  const { setUnidadeSacadoQuery, setDataAgendamento, setCondominioId, setTipoStatusAgendamento } =
    useAgendamentoContatoContext();

  const opcoesStatusAgendamento: SelectOptionType<TipoStatusAgendamentoContato>[] = [
    {
      label: "Agendado",
      value: TipoStatusAgendamentoContato.AGENDADO,
    },
    {
      label: "Agendado para hoje",
      value: TipoStatusAgendamentoContato.AGENDADO_HOJE,
    },
    {
      label: "Atrasado",
      value: TipoStatusAgendamentoContato.ATRASADO,
    },
    {
      label: "Concluido",
      value: TipoStatusAgendamentoContato.CONCLUIDO,
    },
    {
      label: "Próximos 7 dias",
      value: TipoStatusAgendamentoContato.PROXIMO_7_DIAS,
    },
  ];

  return (
    <Row className="mt-4 mb-4">
      <Col xs={3}>
        <SelectCondominios
          label="Condomínio"
          isClearable
          onChange={(opcao) => setCondominioId(opcao?.value)}
        />
      </Col>
      <Col xs={4}>
        <InputSearch
          id="buscar-unidade-sacado"
          label="Buscar por unidade"
          placeholder="Buscar por unidade / sacado"
          onSearchChange={setUnidadeSacadoQuery}
        />
      </Col>
      <Col xs={2}>
        <CustomDatePicker
          label="Data do agendamento"
          usarValidacaoParaFormulario={false}
          dispararOnChangeApenasQuandoDataIsValida
          onChange={(data) => setDataAgendamento(data ? data : null)}
        />
      </Col>
      <Col xs={3}>
        <CustomSelect
          id="select-filtrar-status"
          label="Filtrar por status"
          isClearable
          usarValidacaoParaFormulario={false}
          options={opcoesStatusAgendamento}
          onChange={(opcao) => setTipoStatusAgendamento(opcao?.value)}
        />
      </Col>
    </Row>
  );
}
